import { SvgIcon } from "@mui/material";

const Link = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M8.65,13.94l5.29-5.29a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71l-5.29,5.29a.5.5,0,0,1-.71,0l-.7-.7A.5.5,0,0,1,8.65,13.94ZM21,7.66V8a4,4,0,0,1-1.18,2.84L17,13.67a1.35,1.35,0,0,1-1.9,0L15,13.56a.5.5,0,0,1,0-.7l3.44-3.44A2,2,0,0,0,19,8V7.66a2,2,0,0,0-.59-1.42l-.65-.65A2,2,0,0,0,16.34,5H16a2,2,0,0,0-1.42.59L11.14,9a.5.5,0,0,1-.7,0l-.11-.11a1.35,1.35,0,0,1,0-1.9l2.83-2.84A4,4,0,0,1,16,3h.34a4,4,0,0,1,2.83,1.17l.66.66A4,4,0,0,1,21,7.66ZM12.86,15a.5.5,0,0,1,.7,0l.11.11a1.35,1.35,0,0,1,0,1.9l-2.85,2.85A4,4,0,0,1,8,21H7.66a4,4,0,0,1-2.83-1.17l-.66-.66A4,4,0,0,1,3,16.35V16a4,4,0,0,1,1.18-2.84L7,10.33a1.35,1.35,0,0,1,1.9,0l.11.11a.5.5,0,0,1,0,.7L5.59,14.58A2,2,0,0,0,5,16v.34a2,2,0,0,0,.59,1.42l.65.65A2,2,0,0,0,7.66,19H8a2,2,0,0,0,1.43-.59Z" />
    </SvgIcon>
  );
};

export default Link;
